import { useEffect, useState } from "react";
import { useAppDispatch } from "../app/hooks";
import Loader from "../components/loader";
import { SettingDefinition } from "../service/model/setting-definition.model";
import { getBusinessSettings, getSettingDefinitions, updateBusinessSetting } from "../service/settings.service";
import { Setting } from "../service/model/setting.model";
import SettingRow from "../features/settings/components/setting-row";
import { showNotification } from "../features/alerts/alert.slice";
import { NotificationType } from "../shared/enums";

const Settings = () => {
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [settingDefinitions, setSettingDefinitions] = useState<SettingDefinition[]>([]);
    const [settings, setSettings] = useState<Setting[]>([]);

    const fetchSettingDefinitions = async () => {
        try {
            const response = await getSettingDefinitions();
            setSettingDefinitions(response);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchSettings = async () => {
        try {
            const response = await getBusinessSettings();
            setSettings(response);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        setIsLoading(true);
        fetchSettingDefinitions();
        fetchSettings();
        setIsLoading(false);
    }, []);

    const handleSubmit = async (settingName: string, value: string | number | boolean) => {
        const request = {
            name: settingName,
            value: value
        } as Setting;
        await updateBusinessSetting(request).then(res => {
            fetchSettings();
            dispatch(
                showNotification({
                    message: 'Setting updated successfully',
                    type: NotificationType.Success,
                })
            );
            return res;
        }).catch(err => {
            console.log("🚀 ~ awaitupdateBusinessSetting ~ err:", err)
            dispatch(
                showNotification({
                    message: 'Error occurred while updating status',
                    type: NotificationType.Error,
                })
            );
        });
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {settingDefinitions.map(def => {
                return <SettingRow key={def.name} definition={def} setting={settings.find(setting => setting.name === def.name)} onSave={handleSubmit} />
            })}
        </div>
    )
}

export default Settings;